import React from "react";
import type { FieldError, FieldValues, Path, UseFormRegister } from "react-hook-form";

interface RadioInputProps<TFormValues extends FieldValues = FieldValues> {
  id: string;
  name: Path<TFormValues>;
  value: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label?: React.ReactNode;
  className?: string;
  labelClassName?: string;
  readOnly?: boolean;
  register?: UseFormRegister<TFormValues>;
  error?: FieldError;
}

const RadioInput = <TFormValues extends FieldValues = FieldValues>({
  id,
  name,
  value,
  checked,
  onChange,
  label,
  className = "",
  labelClassName = "",
  readOnly = false,
  register,
  error,
}: RadioInputProps<TFormValues>) => {
  const registration = register ? register(name) : undefined;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    registration?.onChange(e);
    onChange?.(e);
  };

  return (
    <label
      className={`gcw:flex gcw:flex-row gcw:items-center gcw:mb-bs-3 ${checked ? className : ""} ${labelClassName}`}
      htmlFor={id}
    >
      <input
        type="radio"
        id={id}
        name={registration?.name ?? name}
        value={value}
        checked={checked}
        onChange={handleChange}
        onBlur={registration?.onBlur}
        ref={registration?.ref}
        readOnly={readOnly}
        aria-describedby={error ? `${id}-error` : undefined}
      />
      <span className="custom-radio"></span>
      {label}
    </label>
  );
};

export default RadioInput;
